import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { Plan } from "../../class/plan.class";
import { ClientModel } from "../../models/client.model";

export const ClientActions = createActionGroup({
    source: 'Client',
    events: {
        'Login Client': props<{ client:ClientModel}>(),
        'Logout Client': emptyProps(),
        'Load Client': emptyProps(),
        'Set Plan': props<{ plan: Plan }>(),
        'Set Tokens': props<{ tokens: number }>(),
        'Set Tokens Per Month': props<{ tokens: number }>(),
    }
})